"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDetailsCard = void 0;
var react_1 = __importDefault(require("react"));
var typeography_common_1 = require("../typeography/typeography.common");
var material_1 = require("@mui/material");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var format_1 = __importDefault(require("date-fns/format"));
var date_fns_1 = require("date-fns");
var enums_1 = require("../../shared/enums");
var il_button_1 = require("../il-button/il-button");
function UserDetailsCard(_a) {
    var user = _a.user, onClickActivate = _a.onClickActivate, children = _a.children;
    function onClickActiveOrInactive(shouldActivate) {
        onClickActivate && onClickActivate(shouldActivate);
    }
    return (react_1.default.createElement(material_1.Card, { sx: {
            backgroundColor: 'background.default',
            p: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
        } },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'stretch',
                gap: '0.5rem',
                '& .MuiAvatar-root': {
                    width: '1.5rem',
                    height: '1.5rem',
                },
                '& .MuiListItemAvatar-root': {
                    minWidth: '1.5rem',
                },
            } },
            react_1.default.createElement(material_1.ListItemAvatar, null,
                react_1.default.createElement(material_1.Avatar, null,
                    react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: user.avatar }))),
            react_1.default.createElement(typeography_common_1.ILH4, null,
                user.firstName,
                " ",
                user.lastName),
            react_1.default.createElement(typeography_common_1.ILCaption, { sx: {
                    flex: 1,
                    color: 'text.secondary',
                    pt: '0.4rem',
                } }, user.guid),
            user.active && (react_1.default.createElement(il_button_1.ILButton, { onClick: function () { return onClickActiveOrInactive(false); }, sx: {
                    height: '1.5rem',
                    backgroundColor: 'success.main',
                    color: 'text.primary',
                    '&:hover': {
                        backgroundColor: 'success.main',
                        color: 'primary.contrastText',
                    },
                } }, "ACTIVE")),
            !user.active && (react_1.default.createElement(il_button_1.ILButton, { onClick: function () { return onClickActiveOrInactive(true); }, sx: {
                    height: '1.5rem',
                    backgroundColor: 'error.main',
                    color: 'text.primary',
                    '&:hover': {
                        backgroundColor: 'error.main',
                        color: 'primary.contrastText',
                    },
                } }, "INACTIVE"))),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex' } },
            react_1.default.createElement(material_1.Box, { sx: { flex: 1 } },
                react_1.default.createElement(typeography_common_1.ILH5, null, "Username"),
                react_1.default.createElement(typeography_common_1.ILBody1, null, user.username)),
            user.role === enums_1.IdentityRolesEnum.TEACHER && (react_1.default.createElement(material_1.Box, { sx: { flex: 1 } },
                react_1.default.createElement(typeography_common_1.ILH5, null, "Email"),
                react_1.default.createElement(typeography_common_1.ILBody1, null, user.email)))),
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex' } },
            react_1.default.createElement(material_1.Box, { sx: { flex: 1 } },
                react_1.default.createElement(typeography_common_1.ILH5, null, "Last Login"),
                user.lastLoginDate && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(typeography_common_1.ILBody1, null, (0, date_fns_1.formatDistance)(new Date(user.lastLoginDate), new Date(), { addSuffix: true })),
                    react_1.default.createElement(typeography_common_1.ILCaption, null,
                        "(",
                        (0, format_1.default)(new Date(user.lastLoginDate), 'MMM do, yyyy h:mmaaa'),
                        ")"))),
                !user.lastLoginDate && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(typeography_common_1.ILCaption, null, "(Hasn't logged in)")))),
            user.shopifyId && (react_1.default.createElement(material_1.Box, { sx: { flex: 1 } },
                react_1.default.createElement(typeography_common_1.ILH5, null, "Shopify Id"),
                react_1.default.createElement(typeography_common_1.ILBody1, null, user.shopifyId)))),
        children));
}
exports.UserDetailsCard = UserDetailsCard;
